/**
 * QEVIQ social-proof ticker — pause on touch/pointer interaction, resume gently.
 */
(function () {
  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function initTicker(root) {
    if (!root || root.dataset.qsptReady === 'true') return;
    root.dataset.qsptReady = 'true';

    var resumeTimer = null;
    var RESUME_MS = 1800;

    function pause() {
      if (prefersReducedMotion()) return;
      root.classList.add('is-paused');
      if (resumeTimer) {
        clearTimeout(resumeTimer);
        resumeTimer = null;
      }
    }

    function scheduleResume() {
      if (prefersReducedMotion()) return;
      if (resumeTimer) clearTimeout(resumeTimer);
      resumeTimer = setTimeout(function () {
        root.classList.remove('is-paused');
        resumeTimer = null;
      }, RESUME_MS);
    }

    root.addEventListener(
      'pointerdown',
      function () {
        pause();
      },
      { passive: true }
    );

    root.addEventListener(
      'pointerup',
      function () {
        scheduleResume();
      },
      { passive: true }
    );

    root.addEventListener(
      'pointercancel',
      function () {
        scheduleResume();
      },
      { passive: true }
    );

    root.addEventListener(
      'touchend',
      function () {
        scheduleResume();
      },
      { passive: true }
    );

    var viewport = root.querySelector('.qeviq-spt__viewport');
    if (viewport) {
      viewport.addEventListener(
        'scroll',
        function () {
          pause();
          scheduleResume();
        },
        { passive: true }
      );
    }
  }

  function initAll() {
    document.querySelectorAll('[data-qeviq-spt]').forEach(initTicker);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target;
    if (!section) return;
    var root = section.querySelector('[data-qeviq-spt]');
    if (root) {
      root.dataset.qsptReady = 'false';
      initTicker(root);
    }
  });
})();